// extracted by mini-css-extract-plugin
export default {"formHeading":"LH-z","form":"MH-z","submitBtn":"NH-z","disabled":"OH-z","input":"PH-z","error":"QH-z","submitMsg":"RH-z","signIn":"SH-z"};